import { Searchbar } from "../components/searchbar";
import { Accordionservices } from "../components/IconsCarouselCategory";
import { Carouselslide } from "../components/carouselslide";
import { CarouselTopProviders } from "../components/carouselcategory";
import googlePlayIconUrl from "../icons/playstore.svg";
import appleStoreIconUrl from "../icons/apple.svg";
import { Star, User } from "lucide-react";
import { Layout } from "../layout/Layout";
import { useReviews } from "../hooks/services";

const steps = [
	{ id: 1, text: "Describe tu necesidad" },
	{ id: 2, text: "Elige tu profesional" },
	{ id: 3, text: "Hazlo realidad" },
];

const stats = [
	{ value: "1M+", label: "Usuarios Activos" },
	{ value: "24h/7", label: "Respuestas" },
	{ value: "500+", label: "Profesionales" },
	{ value: "100%", label: "Verificado" },
];

export function Landing() {
	const { data: reviewsData, loading: reviewsLoading } = useReviews(
		{ isActive: true, pageSize: 3 },
		true,
	);
	const apiReviews = reviewsData?.items ?? [];
	const reviews = apiReviews;

	return (
		<Layout>
			<div className='w-full overflow-x-hidden bg-neutral-50 pb-24 outline outline-white'>
				<div className='mx-auto w-full max-w-7xl px-4 py-12 sm:px-6 sm:py-14 lg:px-8'>
					<div className='flex flex-col items-center gap-8 sm:gap-10'>
						<h1 className='max-w-2xl text-center text-3xl font-bold leading-tight text-neutral-900 sm:text-4xl sm:leading-tight lg:text-5xl lg:leading-[57.60px]'>
							<span>Mejora </span>
							<span className='text-primary'>tu espacio,</span>
							<span> fácil y rápido</span>
						</h1>
						<div id='searchbar-target' className='w-full max-w-full'>
							<Searchbar />
						</div>
						<div className='w-full max-w-full overflow-hidden'>
							<Accordionservices />
						</div>
						<div className='w-full max-w-full overflow-hidden'>
							<Carouselslide />
						</div>

						<div className='w-full max-w-full overflow-hidden'>
							<CarouselTopProviders />
						</div>
					</div>
				</div>
				<section className='bg-secondary px-4 py-16 sm:px-6 md:py-24 lg:px-8'>
					<div className='mx-auto max-w-7xl relative'>
						{/* Contenedor de la Imagen con bordes redondeados tipo 'pill' */}
						<div className='relative ml-auto h-80 w-full overflow-hidden rounded-4xl shadow-2xl sm:h-96 sm:rounded-[48px] md:h-125 md:w-4/5 md:rounded-tl-[500px] md:rounded-bl-[500px]'>
							<img
								src='https://images.unsplash.com/photo-1512428559087-560fa5ceab42?auto=format&fit=crop&q=80&w=1000'
								alt='Persona usando celular'
								className='w-full h-full object-cover'
							/>
						</div>

						{/* Tarjeta Flotante (Lado Izquierdo) */}
						<div className='-mt-16 z-20 mx-auto w-[calc(100%-1rem)] max-w-md rounded-3xl bg-white p-4 shadow-xl sm:-mt-20 sm:w-full sm:max-w-none sm:rounded-[36px] sm:p-8 md:absolute md:left-0 md:top-1/2 md:mt-0 md:w-100 md:-translate-y-1/2 md:p-12'>
							<h2 className='mb-6 text-xl font-bold text-gray-800 sm:mb-10 sm:text-2xl md:text-3xl'>
								¿Cómo funciona?
							</h2>

							<div className='space-y-4 sm:space-y-6 md:space-y-8'>
								{steps.map((step) => (
									<div
										key={step.id}
										className='flex items-start gap-3 sm:items-center sm:gap-6'
									>
										{/* Círculo numerado */}
										<div className='flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary sm:h-12 sm:w-12'>
											<span className='text-sm font-bold text-primary-hover sm:text-xl'>
												{step.id}
											</span>
										</div>

										{/* Texto del paso */}
										<p className='text-sm font-medium leading-5 text-gray-600 sm:text-lg'>
											{step.text}
										</p>
									</div>
								))}
							</div>
						</div>
					</div>
				</section>
				<section className='bg-white px-4 py-16 sm:px-6 lg:px-8'>
					<div className='mx-auto max-w-7xl text-center'>
						{/* Encabezado */}
						<h2 className='text-3xl md:text-4xl font-bold text-gray-800 mb-4'>
							Tu tarjeta de contactos digital
						</h2>
						<p className='text-gray-600 max-w-3xl mx-auto mb-12 text-lg leading-relaxed'>
							Únete a miles de personas que han encontrado al profesional
							adecuado para el trabajo. Pagos seguros, reseñas verificadas y
							felicidad garantizada.
						</p>

						{/* Grid de Estadísticas */}
						<div className='grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6'>
							{stats.map((stat, index) => (
								<div
									key={index}
									className='border border-gray-200 rounded-[35px] py-10 px-6 flex flex-col items-center justify-center transition-all hover:border-secondary-hover hover:shadow-sm'
								>
									<span className='text-3xl md:text-4xl font-bold text-primary mb-2'>
										{stat.value}
									</span>
									<span className='text-gray-500 font-medium text-sm md:text-base'>
										{stat.label}
									</span>
								</div>
							))}
						</div>
					</div>
				</section>
				<section className='bg-primary overflow-hidden px-4 py-12 sm:px-6 md:py-16 lg:px-8'>
					<div className='mx-auto grid w-full max-w-7xl grid-cols-1 items-center gap-12 md:grid-cols-2'>
						{/* Lado Izquierdo: Texto y Botones */}
						<div className='text-white space-y-8 animate-fade-in'>
							<h2 className='text-4xl md:text-6xl font-extrabold tracking-tight'>
								Descarga la app
							</h2>
							<p className='text-lg md:text-xl opacity-90 max-w-lg leading-relaxed'>
								Accede a miles de profesionales desde tu móvil. Reserva
								servicios, rastrea tu tarea y comunícate con expertos en
								segundos.
							</p>

							<div className='hidden flex-col gap-4 sm:flex-row md:flex'>
								{/* Botón App Store */}
								<a
									href='#'
									className='flex w-full items-center justify-center gap-3 rounded-2xl bg-white px-6 py-3 text-gray-800 shadow-lg transition-transform hover:scale-105 sm:w-auto sm:justify-start'
								>
									<img
										className='h-10 w-10 shrink-0'
										src={appleStoreIconUrl}
										alt=''
										aria-hidden='true'
										draggable={false}
									/>
									<div className='min-w-0 flex flex-col'>
										<span className='text-[10px] uppercase leading-none text-text-tertiary'>
											Descarga en
										</span>
										<span className='text-xl font-bold leading-tight text-primary'>
											App Store
										</span>
									</div>
								</a>

								{/* Botón Google Play */}
								<a
									href='#'
									className='flex w-full items-center justify-center gap-3 rounded-2xl bg-white px-6 py-3 text-gray-800 shadow-lg transition-transform hover:scale-105 sm:w-auto sm:justify-start'
								>
									<img
										className='h-10 w-10 shrink-0'
										src={googlePlayIconUrl}
										alt=''
										aria-hidden='true'
										draggable={false}
									/>
									<div className='min-w-0 flex flex-col'>
										<span className='text-[10px] uppercase leading-none text-text-tertiary'>
											Descarga en
										</span>
										<span className='text-xl font-bold leading-tight text-primary'>
											Google Play
										</span>
									</div>
								</a>
							</div>
						</div>

						{/* Lado Derecho: Mockup de Teléfono */}
						<div className='relative flex min-w-0 justify-center'>
							{/* El marco del teléfono se eleva en desktop para dar dinamismo */}
							<div className='relative h-125 w-58 rounded-[3rem] border-8 border-gray-800 bg-black p-3 shadow-2xl sm:h-135 sm:w-62 md:h-162.5 md:w-[320px]'>
								<div className='landing-phone-splash relative w-full h-full rounded-[2.2rem] overflow-hidden'>
									<div className='landing-phone-splash__panel landing-phone-splash__panel--left' />
									<div className='landing-phone-splash__panel landing-phone-splash__panel--right' />
									<div className='landing-phone-splash__logo-wrap'>
										<div className='landing-phone-splash__logo-motion'>
											<img
												src='/servix_splash_logo.svg'
												alt='Animación de entrada de Servix'
												className='landing-phone-splash__logo'
												draggable={false}
											/>
										</div>
									</div>
									<div className='landing-phone-splash__notch pointer-events-none absolute left-1/2 top-0 h-6 w-1/2 -translate-x-1/2 rounded-b-2xl bg-black'></div>
								</div>
								{/* Botones laterales simulados */}
								<div className='absolute -left-2 top-24 w-1 h-12 bg-gray-700 rounded-l-md'></div>
								<div className='absolute -left-2 top-40 w-1 h-12 bg-gray-700 rounded-l-md'></div>
								<div className='absolute -right-2 top-32 w-1 h-16 bg-gray-700 rounded-r-md'></div>
							</div>
						</div>

						<div className='mt-8 flex flex-col gap-4 md:hidden'>
							{/* Botón App Store */}
							<a
								href='#'
								className='flex w-full items-center justify-center gap-3 rounded-2xl bg-white px-6 py-3 text-gray-800 shadow-lg transition-transform hover:scale-105'
							>
								<img
									className='h-10 w-10 shrink-0'
									src={appleStoreIconUrl}
									alt=''
									aria-hidden='true'
									draggable={false}
								/>
								<div className='min-w-0 flex flex-col'>
									<span className='text-[10px] uppercase leading-none text-text-tertiary'>
										Descarga en
									</span>
									<span className='text-xl font-bold leading-tight text-primary'>
										App Store
									</span>
								</div>
							</a>

							{/* Botón Google Play */}
							<a
								href='#'
								className='flex w-full items-center justify-center gap-3 rounded-2xl bg-white px-6 py-3 text-gray-800 shadow-lg transition-transform hover:scale-105'
							>
								<img
									className='h-10 w-10 shrink-0'
									src={googlePlayIconUrl}
									alt=''
									aria-hidden='true'
									draggable={false}
								/>
								<div className='min-w-0 flex flex-col'>
									<span className='text-[10px] uppercase leading-none text-text-tertiary'>
										Descarga en
									</span>
									<span className='text-xl font-bold leading-tight text-primary'>
										Google Play
									</span>
								</div>
							</a>
						</div>
					</div>
				</section>
				<section className='bg-white px-4 py-16 sm:px-6 md:py-24 lg:px-8'>
					<div className='mx-auto max-w-7xl'>
						<h2 className='text-3xl md:text-4xl font-bold text-center text-gray-800 mb-16'>
							Lo que dicen nuestros usuarios
						</h2>

						<div className='grid grid-cols-1 md:grid-cols-3 gap-8'>
							{reviewsLoading
								? [...Array(3)].map((_, i) => (
										<div
											key={i}
											className='bg-white border border-gray-100 rounded-[40px] p-10 shadow-sm flex flex-col gap-4 animate-pulse'
										>
											<div className='flex gap-1'>
												{[...Array(5)].map((_, j) => (
													<div
														key={j}
														className='w-5 h-5 bg-gray-200 rounded-full'
													/>
												))}
											</div>
											<div className='h-4 bg-gray-200 rounded w-full' />
											<div className='h-4 bg-gray-200 rounded w-4/5' />
											<div className='h-4 bg-gray-200 rounded w-3/5' />
											<div className='mt-auto flex items-center gap-3 pt-4'>
												<div className='w-10 h-10 bg-gray-200 rounded-full' />
												<div className='h-4 bg-gray-200 rounded w-24' />
											</div>
										</div>
									))
								: reviews.map((review) => (
										<div
											key={review.id}
											className='bg-white border border-gray-100 rounded-[40px] p-10 shadow-sm flex flex-col transition-all hover:shadow-md'
										>
											{/* Estrellas según puntuación real */}
											<div className='flex gap-1 mb-6'>
												{[1, 2, 3, 4, 5].map((s) => (
													<Star
														key={s}
														className={`w-5 h-5 ${review.punctuation >= s ? "fill-primary text-primary" : "text-gray-200"}`}
													/>
												))}
											</div>

											{/* Comentario real */}
											<p className='text-gray-600 text-lg leading-relaxed mb-8 flex-1'>
												"{review.comment_review}"
											</p>

											{/* Autor real */}
											<div className='mt-auto flex items-center gap-3'>
												<div className='w-10 h-10 rounded-full bg-secondary flex items-center justify-center shrink-0'>
													{review.qualifier?.image_profile ? (
														<img
															src={
																review.qualifier
																	.image_profile
															}
															alt=''
															className='w-full h-full rounded-full object-cover'
														/>
													) : (
														<User className='w-5 h-5 text-primary' />
													)}
												</div>
												<span className='text-gray-700 font-medium text-base'>
													{review.qualifier
														? `${review.qualifier.names} ${review.qualifier.last_names}`
														: `Usuario #${review.qualifier_id}`}
												</span>
											</div>
										</div>
									))}
						</div>
					</div>
				</section>
			</div>
		</Layout>
	);
}
